import React from 'react';

const ChevronDownIcon24 = ({ className }) => (
  <svg className={className} height="24" width="24">
    <path d="m7.41 9 4.59 4.59 4.59-4.59 1.41 1.42-6 6-6-6z" />
  </svg>
);

export default ChevronDownIcon24;
